<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="engagement-summary">
    <div>
      <label class="title"
        >Total MS Engagement Revenue -
        <strong>${{ engagementRevenue }}M per year</strong>
      </label>
      <table>
        <thead>
          <tr>
            <th *ngFor="let head of headerList">
              <label>
                {{ head?.label }}
              </label>
            </th>
          </tr>
        </thead>
      </table>
      <div class="scrollTable">
        <motif-accordion
            togglePosition="after"
            type="default"
            hideToggle="false"
            [multi]="false">
            <motif-expansion-panel *ngFor="let engagement of engagements | keyvalue">
              <motif-expansion-panel-header role="button" [alternativeTriggerIcon]="false">
                <motif-panel-title>{{ engagement.key }}</motif-panel-title>
              </motif-expansion-panel-header>
                <table>
                  <tbody>
                    <tr class="engagementTr" *ngFor="let item of engagement.value" (click)="redirectEngagementDetails(item.name)">
                      <td>{{ item?.name }}</td>
                      <td>{{ item?.startDate | date : "dd/MM/yyyy" }}</td>
                      <td>
                        <div class="metrics">
                          <div
                            [ngClass]="
                              { '1': 'good', '2': 'poor', '3': 'avg' }[metric.status]
                            "
                            *ngFor="let metric of item.metrics"
                          >
                            {{ metric?.count }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="view-button">
                          <img src="/assets/images/key-contacts.svg" />
                        </div>
                      </td>
                      <td>
                        <div class="view-button">
                          <img src="/assets/images/nav-arrow-right.svg" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </motif-expansion-panel>
          </motif-accordion>
      </div>
    </div>
    <div class="engagement-footer">
      <div class="legends">
        <div class="legend">
          <div class="poor"></div>
          Poor
        </div>
        <div class="legend">
          <div class="avg"></div>
          Average
        </div>
        <div class="legend">
          <div class="good"></div>
          Good
        </div>
      </div>
      <!-- <div class="view-all">View All</div> -->
    </div>
    <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
